/* === ZAFFRONIQUE Locale Link Fixer === */
/* Automatically prefixes internal links with the current locale */
(function() {
  'use strict';

  // Detect current locale from URL path
  // If path starts with /en, /fr, /it etc. — extract it
  var pathParts = window.location.pathname.split('/').filter(Boolean);
  var supportedLocales = ['en']; // Add more locales here if needed: ['en', 'fr', 'it']

  // If first path segment is a supported locale, use it as prefix
  var localePrefix = '';
  if (pathParts.length > 0 && supportedLocales.indexOf(pathParts[0]) !== -1) {
    localePrefix = '/' + pathParts[0];
  }

  // If no locale prefix detected, nothing to do
  if (!localePrefix) return;

  // Find all internal links to blogs, products, pages, collections
  // and rewrite them to include the locale prefix
  function fixLinks() {
    var links = document.querySelectorAll('a[href]');
    links.forEach(function(link) {
      var href = link.getAttribute('href');

      // Only process internal absolute paths
      if (!href || !href.startsWith('/')) return;

      // Skip if already locale-prefixed
      if (href.indexOf(localePrefix + '/') === 0 || href === localePrefix) return;

      // Only rewrite paths to blogs, products, pages, collections
      if (href.startsWith('/blogs/') ||
          href.startsWith('/products/') ||
          href.startsWith('/pages/') ||
          href.startsWith('/collections/')) {
        link.setAttribute('href', localePrefix + href);
      }
    });
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixLinks);
  } else {
    fixLinks();
  }
})();